import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import moment from 'moment';
import warehouseMerchandiseItem from 'types/warehouseMerchandiseItem';
import { FontIcon } from 'react-toolbox';
import PhaseType from 'types/phase';
import S from './printLabel.scss';

class PrintLabel extends Component {

  buildQuery = () => {
    const { phase, lineItem, padInfo } = this.props;
    const { received_quantity: quantity, tag_number: tagNumber, bin,
      item_name: itemName } = lineItem;
    const { details } = phase;
    const { customer_name: customerName, store } = details;
    const dateReceived = lineItem.date_received ?
      moment(lineItem.date_received).format('MM/DD/YYYY') : null;
    const b64Query = btoa(JSON.stringify([{
      storeNumber: store.number,
      customerName,
      poNumber: lineItem.po_number,
      quantity,
      dateReceived,
      tagNumber,
      bin,
      itemName: itemName.replace(/\s\s+/g, ' ').trim(),
      pads: padInfo,
    }]));
    return { queryData: JSON.stringify(b64Query) };
  }

  render = () => (<Link
    className={S.anchor}
    to={{ pathname: '/print-label', query: this.buildQuery() }}
    target="_blank"
  >
    <FontIcon className={S.icon} value="ic_print" />
  </Link>);
}

PrintLabel.propTypes = {
  lineItem: PropTypes.shape(warehouseMerchandiseItem),
  phase: PhaseType.isRequired,
  padInfo: PropTypes.arrayOf(PropTypes.shape({ cut_quantity: PropTypes.string })),
};

export default connect(state => ({ phase: state.phase }))(PrintLabel);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/printLabel.jsx